import React from 'react'
import { Container, Navbar } from 'react-bootstrap'
import whitelogo from "./../../images/white-logo.png"
import { Link } from 'react-router-dom'
import UseLogged from '../../CustomHooks/Auth/UseLogged'
import { FaBars } from "react-icons/fa";
import UseViewHide from '../../CustomHooks/UseViewHide'

const AdminNavBar = ({handleSideBarView}) => {
    const [isLogin, LogOut, role, token] = UseLogged();
    
    return (
        <Navbar className="dark-bg">
            <Container fluid className='justify-content-between'>
                <Navbar.Brand>
                    <a href='/'>
                        <img src={whitelogo} className='logo' alt="logo" />
                    </a>
                </Navbar.Brand>
                <div>
                    <Link to="/" onClick={LogOut} className='text-white fw-bold'>LogOut</Link>
                    {isLogin && role ? (role === "admin" ? (<FaBars className="text-white ms-3 d-lg-none d-inline-block" onClick={handleSideBarView}/>) : (null)) : null}
                </div>
            </Container>
        </Navbar >
    )
}

export default AdminNavBar
